document.addEventListener('DOMContentLoaded', function () {
    const navToggle = document.getElementById('navbarToggle');
    const primaryNav = document.getElementById('primaryNavigation');
    let focusableElements = [];
    let firstFocusableElement = null;
    let lastFocusableElement = null;

    function getFocusableElements() {
        if (!primaryNav) return;

        const focusableSelectors = [
            'a[href]',
            'button:not([disabled])',
            'input:not([disabled])',
            'select:not([disabled])',
            'textarea:not([disabled])',
            '[tabindex]:not([tabindex="-1"])'
        ];

        focusableElements = primaryNav.querySelectorAll(focusableSelectors.join(', '));
        focusableElements = Array.from(focusableElements).filter(el => {
            return el.offsetParent !== null;
        });

        if (focusableElements.length > 0) {
            firstFocusableElement = focusableElements[0];
            lastFocusableElement = focusableElements[focusableElements.length - 1];
        }
    }

    // Handle TAB key for focus trapping
    function handleTabKey(e) {
        if (!navToggle || !primaryNav) return;

        // Check if nav is open using your custom class
        const isNavOpen = primaryNav.classList.contains('is-expanded');

        if (!isNavOpen) return; // Only trap focus when nav is open

        getFocusableElements(); // Refresh focusable elements

        if (focusableElements.length === 0) return;

        // If shift+tab on first element, go to last
        if (e.shiftKey && document.activeElement === firstFocusableElement) {
            e.preventDefault();
            lastFocusableElement.focus();
        }
        // If tab on last element, go to first
        else if (!e.shiftKey && document.activeElement === lastFocusableElement) {
            e.preventDefault();
            firstFocusableElement.focus();
        }
    }

    // Global keydown handler for ESC and TAB
    document.addEventListener('keydown', function(e) {
        // Handle TAB key for focus trapping
        if (e.key === 'Tab' || e.keyCode === 9) {
            handleTabKey(e);
        }

        // Handle ESC key
        if (e.key === 'Escape') {
            if (!navToggle || !primaryNav) return;

            // Check if nav is open using your custom class
            const isOpen = primaryNav.classList.contains('is-expanded');

            if (isOpen) {
                navToggle.click(); // Simulate click to close (uses your jQuery handler)
                navToggle.focus(); // Return focus
            }
        }
    });
});


(function($) {
    // Toggle collapse on submenu
    $('#navbarToggle').on('click', function() {
        var primaryNavigation = $('#primaryNavigation');
        $this = $(this);

        // Dropdown toggle setup
        if(primaryNavigation.hasClass('is-expanded')) {
            primaryNavigation.removeClass('is-expanded');
            $('body').removeClass('no-scroll');
            $this.addClass('collapsed');
            $this.attr('aria-expanded', 'false');

        } else {
            primaryNavigation.addClass('is-expanded');
            $('body').addClass('no-scroll');
            $this.removeClass('collapsed');
            $this.attr('aria-expanded', 'true');

            // Focus first navigation link when opening
            setTimeout(function() {
                var firstLink = primaryNavigation.find('a:first');
                if (firstLink.length) {
                    firstLink.focus();
                }
            }, 100);
        }
    });
}(jQuery));

